import _ from "lodash";
import { useMemo } from "react";
import { useBalanceStore } from "../../../_store/balanceStore";
import { useInvestStore } from "../../../_store/investStore";
import { DonutChartInvestMain } from "../../../components/chart/DonutChartMain";
import { cn, toFloat2 } from "../../../utils/useFunctions";
import { key_property_invest_category } from "../../balance/functions";
import { PdfCard, PdfCardWhite } from "../component/pdf.c.card";
import PdfFooter from "../component/pdf.c.footer";
import PdfHeader from "../component/pdf.c.header";
import { PdfHeaderText } from "../component/pdf.c.headerText";
import PdfLine from "../component/pdf.c.line";
import {
  STYLE_PAGE,
  STYLE_PDF_TEXT_MEDIUM_11,
  STYLE_PDF_TEXT_NORMAL_11,
  STYLE_PDF_TEXT_SEMIBOLD_BLUE_12,
} from "../styles/pdf.style";

function PdfPageInvestOne({ page }) {
  const balanceData = useBalanceStore((state) => state?.balanceData);

  const investData = useInvestStore((state) => state.investData);

  const result = investData?.sum_score;

  const checkLevel = () => {
    if (result < 15) {
      return "1";
    } else if (result > 15 && result < 21) {
      return "2";
    } else if (result > 22 && result < 29) {
      return "3";
    } else if (result > 30 && result < 36) {
      return "4";
    } else {
      return "5";
    }
  };

  const checkLevelTitle = () => {
    if (result < 15) {
      return "รับความเสี่ยงระดับต่ำ";
    } else if (result > 15 && result < 21) {
      return "รับความเสี่ยงระดับต่ำ-ปานกลาง";
    } else if (result > 22 && result < 29) {
      return "รับความเสี่ยงระดับปานกลาง";
    } else if (result > 30 && result < 36) {
      return "รับความเสี่ยงระดับปานกลาง-สูง";
    } else {
      return "รับความเสี่ยงระดับสูง";
    }
  };

  const investRecommendItems = useMemo(() => {
    if (result < 15) {
      return [
        {
          label: "พอร์ตเป้าหมายระยะสั้น 0-3 ปี",
          items: [
            {
              label: "ตราสารหนี้",
              value: 50,
            },
            {
              label: "เงินฝาก",
              value: 50,
            },
          ],
          returns: [
            {
              label: "ผลตอบแทนคาดหวัง",
              value: "1.23%",
            },
            {
              label: "ผลตอบแทนปรับฐาน (-1SD)",
              value: "0.80%",
            },
            {
              label: "ผลตอบแทนปรับฐาน (-2SD)",
              value: "0.40%",
            },
          ],
        },
        {
          label: "พอร์ตเป้าหมายระยะกลาง 3-7 ปี",
          items: [
            {
              label: "ตราสารทุน",
              value: 10,
            },
            {
              label: "ตราสารหนี้",
              value: 90,
            },
          ],
          returns: [
            {
              label: "ผลตอบแทนคาดหวัง",
              value: "2.56%",
            },
            {
              label: "ผลตอบแทนปรับฐาน (-1SD)",
              value: "0.00%",
            },
            {
              label: "ผลตอบแทนปรับฐาน (-2SD)",
              value: "-2.60%",
            },
          ],
        },
        {
          label: "พอร์ตเป้าหมายระยะยาว 7 ปีขึ้นไป",
          items: [
            {
              label: "ตราสารทุน",
              value: 20,
            },
            {
              label: "ตราสารหนี้",
              value: 80,
            },
          ],
          returns: [
            {
              label: "ผลตอบแทนคาดหวัง",
              value: "2.73%",
            },
            {
              label: "ผลตอบแทนปรับฐาน (-1SD)",
              value: "-1.20%",
            },
            {
              label: "ผลตอบแทนปรับฐาน (-2SD)",
              value: "-5.20%",
            },
          ],
        },
      ];
    } else if (result > 15 && result < 21) {
      return [
        {
          label: "พอร์ตเป้าหมายระยะสั้น 0-3 ปี",
          items: [
            {
              label: "ตราสารทุน",
              value: 15,
            },
            {
              label: "ตราสารหนี้",
              value: 75,
            },
            {
              label: "เงินฝาก",
              value: 10,
            },
          ],
          returns: [
            {
              label: "ผลตอบแทนคาดหวัง",
              value: "1.34%",
            },
            {
              label: "ผลตอบแทนปรับฐาน (-1SD)",
              value: "-0.50%",
            },
            {
              label: "ผลตอบแทนปรับฐาน (-2SD)",
              value: "-2.30%",
            },
          ],
        },
        {
          label: "พอร์ตเป้าหมายระยะกลาง 3-7 ปี",
          items: [
            {
              label: "ตราสารทุน",
              value: 30,
            },
            {
              label: "ตราสารหนี้",
              value: 70,
            },
          ],
          returns: [
            {
              label: "ผลตอบแทนคาดหวัง",
              value: "3.82%",
            },
            {
              label: "ผลตอบแทนปรับฐาน (-1SD)",
              value: "-1.90%",
            },
            {
              label: "ผลตอบแทนปรับฐาน (-2SD)",
              value: "-7.60%",
            },
          ],
        },
        {
          label: "พอร์ตเป้าหมายระยะยาว 7 ปีขึ้นไป",
          items: [
            {
              label: "ตราสารทุน",
              value: 30,
            },
            {
              label: "ตราสารหนี้",
              value: 70,
            },
          ],
          returns: [
            {
              label: "ผลตอบแทนคาดหวัง",
              value: "3.82%",
            },
            {
              label: "ผลตอบแทนปรับฐาน (-1SD)",
              value: "-1.90%",
            },
            {
              label: "ผลตอบแทนปรับฐาน (-2SD)",
              value: "-7.60%",
            },
          ],
        },
      ];
    } else if (result > 22 && result < 29) {
      return [
        {
          label: "พอร์ตเป้าหมายระยะสั้น 0-3 ปี",
          items: [
            {
              label: "ตราสารทุน",
              value: 25,
            },
            {
              label: "ตราสารหนี้",
              value: 75,
            },
          ],
          returns: [
            {
              label: "ผลตอบแทนคาดหวัง",
              value: "2.49%",
            },
            {
              label: "ผลตอบแทนปรับฐาน (-1SD)",
              value: "-1.10%",
            },
            {
              label: "ผลตอบแทนปรับฐาน (-2SD)",
              value: "-4.70%",
            },
          ],
        },
        {
          label: "พอร์ตเป้าหมายระยะกลาง 3-7 ปี",
          items: [
            {
              label: "ตราสารทุน",
              value: 30,
            },
            {
              label: "ตราสารหนี้",
              value: 65,
            },
            {
              label: "สินทรัพย์ทางเลือก",
              value: 5,
            },
          ],
          returns: [
            {
              label: "ผลตอบแทนคาดหวัง",
              value: "4.43%",
            },
            {
              label: "ผลตอบแทนปรับฐาน (-1SD)",
              value: "-1.90%",
            },
            {
              label: "ผลตอบแทนปรับฐาน (-2SD)",
              value: "-8.10%",
            },
          ],
        },
        {
          label: "พอร์ตเป้าหมายระยะยาว 7 ปีขึ้นไป",
          items: [
            {
              label: "ตราสารทุน",
              value: 30,
            },
            {
              label: "ตราสารหนี้",
              value: 60,
            },
            {
              label: "สินทรัพย์ทางเลือก",
              value: 10,
            },
          ],
          returns: [
            {
              label: "ผลตอบแทนคาดหวัง",
              value: "4.33%",
            },
            {
              label: "ผลตอบแทนปรับฐาน (-1SD)",
              value: "-2.50%",
            },
            {
              label: "ผลตอบแทนปรับฐาน (-2SD)",
              value: "-9.40%",
            },
          ],
        },
      ];
    } else if (result > 30 && result < 36) {
      return [
        {
          label: "พอร์ตเป้าหมายระยะสั้น 0-3 ปี",
          items: [
            {
              label: "ตราสารทุน",
              value: 25,
            },
            {
              label: "ตราสารหนี้",
              value: 75,
            },
          ],
          returns: [
            {
              label: "ผลตอบแทนคาดหวัง",
              value: "2.49%",
            },
            {
              label: "ผลตอบแทนปรับฐาน (-1SD)",
              value: "-1.10%",
            },
            {
              label: "ผลตอบแทนปรับฐาน (-2SD)",
              value: "-4.70%",
            },
          ],
        },
        {
          label: "พอร์ตเป้าหมายระยะกลาง 3-7 ปี",
          items: [
            {
              label: "ตราสารทุน",
              value: 40,
            },
            {
              label: "ตราสารหนี้",
              value: 50,
            },

            {
              label: "สินทรัพย์ทางเลือก",
              value: 10,
            },
          ],
          returns: [
            {
              label: "ผลตอบแทนคาดหวัง",
              value: "5.41%",
            },
            {
              label: "ผลตอบแทนปรับฐาน (-1SD)",
              value: "-3.20%",
            },
            {
              label: "ผลตอบแทนปรับฐาน (-2SD)",
              value: "-11.80%",
            },
          ],
        },
        {
          label: "พอร์ตเป้าหมายระยะยาว 7 ปีขึ้นไป",
          items: [
            {
              label: "ตราสารทุน",
              value: 40,
            },
            {
              label: "ตราสารหนี้",
              value: 40,
            },
            {
              label: "สินทรัพย์ทางเลือก",
              value: 20,
            },
          ],
          returns: [
            {
              label: "ผลตอบแทนคาดหวัง",
              value: "5.93%",
            },
            {
              label: "ผลตอบแทนปรับฐาน (-1SD)",
              value: "-3.70%",
            },
            {
              label: "ผลตอบแทนปรับฐาน (-2SD)",
              value: "-13.30%",
            },
          ],
        },
      ];
    } else {
      return [
        {
          label: "พอร์ตเป้าหมายระยะสั้น 0-3 ปี",
          items: [
            {
              label: "ตราสารทุน",
              value: 25,
            },
            {
              label: "ตราสารหนี้",
              value: 75,
            },
          ],
          returns: [
            {
              label: "ผลตอบแทนคาดหวัง",
              value: "2.49%",
            },
            {
              label: "ผลตอบแทนปรับฐาน (-1SD)",
              value: "-1.10%",
            },
            {
              label: "ผลตอบแทนปรับฐาน (-2SD)",
              value: "-4.70%",
            },
          ],
        },
        {
          label: "พอร์ตเป้าหมายระยะกลาง 3-7 ปี",
          items: [
            {
              label: "ตราสารทุน",
              value: 40,
            },
            {
              label: "ตราสารหนี้",
              value: 50,
            },
            {
              label: "สินทรัพย์ทางเลือก",
              value: 40,
            },
          ],
          returns: [
            {
              label: "ผลตอบแทนคาดหวัง",
              value: "5.41%",
            },
            {
              label: "ผลตอบแทนปรับฐาน (-1SD)",
              value: "-3.20%",
            },
            {
              label: "ผลตอบแทนปรับฐาน (-2SD)",
              value: "-11.80%",
            },
          ],
        },
        {
          label: "พอร์ตเป้าหมายระยะยาว 7 ปีขึ้นไป",
          items: [
            {
              label: "ตราสารทุน",
              value: 80,
            },
            {
              label: "สินทรัพย์ทางเลือก",
              value: 20,
            },
          ],
          returns: [
            {
              label: "ผลตอบแทนคาดหวัง",
              value: "8.79%",
            },
            {
              label: "ผลตอบแทนปรับฐาน (-1SD)",
              value: "-7.50%",
            },
            {
              label: "ผลตอบแทนปรับฐาน (-2SD)",
              value: "-23.80%",
            },
          ],
        },
      ];
    }
  }, []);

  const investItems = useMemo(() => {
    const DebtInvestLists = balanceData?.debt_long_list
      ?.map((item) => {
        if (item?.options_debt_long === "debt_long_other") {
          let tempOthers = item.debt_long_others?.flat();
          tempOthers = tempOthers?.map((other) => ({
            ...other,
            options_debt_long: "debt_long_other",
          }));
          return tempOthers;
        }

        if (item?.options_debt_long === "debt_place") {
          let tempPlaces = item.debt_long_places?.flat();
          tempPlaces = tempPlaces?.map((place) => ({
            ...place,
            options_debt_long: "debt_place",
          }));
          return tempPlaces;
        }

        if (item?.options_debt_long === "debt_car") {
          let tempCars = item.debt_long_cars?.flat();
          tempCars = tempCars?.map((car) => ({
            ...car,
            options_debt_long: "debt_car",
          }));
          return tempCars;
        }
        return null;
      })
      ?.flat()
      .filter((item) => item?.personal_or_investment === "investment");


    const tempDebtInvest = balanceData?.debt_long_list
      ?.map(
        (item) =>
          item?.debt_long_others ||
          item?.debt_long_places ||
          item?.debt_long_cars
      )
      ?.flat()
      .filter((item) => item?.personal_or_investment === "investment");

    const totalDebtInvest = tempDebtInvest?.reduce((prev, curr) => {
      if (curr?.type_car) {
        return prev  + Number(curr?.start_amount || 0);
      }
      return prev + Number(curr?.current_price || 0) ;
    }, 0);

    if (
      !balanceData?.property_invest_list?.length &&
      DebtInvestLists?.length === 0
    )
      return [];

    const filterPropertyInvest = balanceData?.property_invest_list?.filter(
      (item) => item?.options_property_invest_category
    );

    const groupInvest = _.groupBy(
      filterPropertyInvest,
      "options_property_invest_category"
    );

    const keyInvest =
      tempDebtInvest?.length > 0 && ![...Object.keys(groupInvest)].includes("property_other")
        ? [...Object.keys(groupInvest), "property_other"]
        : Object.keys(groupInvest);

    let convertGroupInvest = keyInvest?.map((key) => {
      const amount = groupInvest[key]?.reduce((prev, curr) => {
        const itemKeys = Object.keys(curr);
        for (const itemKey of itemKeys) {
          const itemValue = curr[itemKey];
          if (_.isArray(itemValue)) {
            return (
              prev + itemValue?.reduce((prev, curr) => prev + Number(curr.amount || 0), 0)
            );
          }
        }
      }, 0) || 0;

      return {
        key,
        label: key_property_invest_category[key],
        value: key === 'property_other' ? amount + totalDebtInvest :amount,
        amount: key === 'property_other' ? amount + totalDebtInvest :amount,
      };
    });


    const newItems = [];
    let total = convertGroupInvest?.reduce((prev, curr) => prev + curr.value, 0);

    for (const convertGroupInvestItem of convertGroupInvest) {
      const createItem = {
        label: convertGroupInvestItem.label,
        value: (convertGroupInvestItem.amount / total) * 100,
        amount: convertGroupInvestItem.amount,
      };
      newItems.push(createItem);
    }


    // clean data
    const cleanItems = newItems?.map((item) => {
      return {
        label: item.label,
        value: toFloat2(item.value),
        amount: item.amount,
      };
    });

    const sortItems = [
      {
        label: "ตราสารทุน",
      },
      {
        label: "ตราสารหนี้",
      },
      {
        label: "ตลาดเงิน",
      },
      {
        label: "เงินฝาก",
      },
      {
        label: "สินทรัพย์ทางเลือก",
      },
    ];

    const sortItemsMap = sortItems?.map((sortItem) => {
      const findItem = cleanItems.find((item) => item.label === sortItem.label);
      return findItem;
    });


    return sortItemsMap;
  }, [balanceData]);



  if (investItems?.length === 0) {
    return
  }

  return (
    <div className={cn(STYLE_PAGE)}>
      <PdfHeader />
      <PdfLine />
      <PdfHeaderText title="การจัดทัพการลงทุน" icon="/images/revenue.svg" />
      {/* การจัดทัพการลงทุน */}
      <PdfCard className={"flex flex-col space-y-3"}>
        <div className="flex justify-between">
          <div className={cn(STYLE_PDF_TEXT_MEDIUM_11)}>สัดส่วนลงทุนของคุณ</div>
        </div>
        <PdfCardWhite className={cn("flex space-x-2 justify-center")}>
          <DonutChartInvestMain
            classNameRoot={cn("flex flex-row justify-center items-center")}
            className={cn("w-[200px] h-[200px] pt-0  ")}
            classNameText={cn(STYLE_PDF_TEXT_NORMAL_11)}
            width={20}
            height={20}
            items={investItems?.filter((item) => item?.value > 0)}
            isAmount
          />

          {/* <div className={cn(STYLE_PDF_TEXT_MEDIUM_11)}>
            พอร์ตเป้าหมายระยะยาว 7 ปีขึ้นไป 
          </div> */}
        </PdfCardWhite>
      </PdfCard>

      <PdfCard className={"flex flex-col space-y-3"}>
        <div className="flex justify-between">
          <div className={cn(STYLE_PDF_TEXT_MEDIUM_11)}>
            สัดส่วนการลงทุนที่แนะนำ
          </div>
          <div className={cn(STYLE_PDF_TEXT_SEMIBOLD_BLUE_12, "text-[13px]")}>
            ประเภทนักลงทุน{checkLevelTitle()} (ระดับ {checkLevel()})
          </div>
        </div>

        <div className={cn("grid grid-cols-3 gap-3")}>
          {investRecommendItems?.map((item, index) => {
            return (
              <PdfCardWhite
                key={index}
                className={cn("flex flex-col items-center justify-center")}
              >
                <div className={cn(STYLE_PDF_TEXT_MEDIUM_11)}>{item.label}</div>
                <DonutChartInvestMain
                  className={cn("w-[140px] h-[140px] flex justify-center pt-0")}
                  classNameText={cn(STYLE_PDF_TEXT_NORMAL_11, "!text-[9px]")}
                  width={20}
                  height={20}
                  items={item.items}
                />
                <div className="mt-1"></div>
                <div className="flex bg-gray-100 mt-auto rounded p-2 space-y-1 flex-col items-center">
                  {item?.returns?.map((item, index) => {
                    return (
                      <div
                        key={index}
                        className={cn(
                          "flex space-x-2 text-[8px] justify-between w-full"
                        )}
                      >
                        <div>{item?.label}</div>
                        <div>{item?.value}</div>
                      </div>
                    );
                  })}
                </div>
              </PdfCardWhite>
            );
          })}
        </div>
      </PdfCard>
      <PdfFooter page={page} />
    </div>
  );
}

export default PdfPageInvestOne;
